import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, TextField, MenuItem, CircularProgress } from "@mui/material";
import MDButton from "components/MDButton";
import { useAlerta } from "utils/alertas";

export default function EditarModuloModal({ open, onClose, moduloId, onModuloActualizado }) {
  const [loading, setLoading] = useState(false);
  const [cargandoDatos, setCargandoDatos] = useState(true);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [duracion, setDuracion] = useState("");
  const [instituto, setInstituto] = useState("");
  const [costo, setCosto] = useState("");
  const [estado, setEstado] = useState(1);
  const { mostrarAlerta } = useAlerta();
  const token = sessionStorage.getItem("access_token");

  // Traer info del módulo cuando se abre el modal o cambia el id
  useEffect(() => {
    if (!moduloId) return;

    setCargandoDatos(true);
    fetch(`${process.env.REACT_APP_API_URL}/modulos/${moduloId}`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then(res => res.json())
      .then(data => {
        const modulo = data.data || data; // depende de tu backend
        setNombre(modulo.nombre || "");
        setDescripcion(modulo.descripcion || "");
        setFechaInicio(modulo.fecha_inicio || "");
        setFechaFin(modulo.fecha_fin || "");
        setDuracion(modulo.duracion || "");
        setCosto(modulo.costo || "");
        setEstado(modulo.estado ?? 1);
        setInstituto(modulo.instituto ?? "");
        setCargandoDatos(false);
      })
      .catch(err => {
        console.error(err);
        setCargandoDatos(false);
      });
  }, [moduloId, token]);

  const handleSubmit = () => {
    setLoading(true);
    const payload = {
      nombre,
      descripcion,
      fecha_inicio: fechaInicio || null,
      fecha_fin: fechaFin || null,
      duracion,
      costo: costo ? parseFloat(costo) : null,
      estado,
    };

    fetch(`${process.env.REACT_APP_API_URL}/modulos/${moduloId}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        onModuloActualizado(); // recarga la lista en el padre
        mostrarAlerta("Capacitacion actualizada correctamente", "success");
        onClose();
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box 
        sx={{ 
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // padding responsive
          width: { xs: '90%', sm: 400, md: 500 }, // 🔥 clave
          maxHeight: '90vh', // evita que se salga de pantalla
          overflowY: 'auto', // scroll interno
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}>
        <Typography variant="h6" mb={2}>
          Editar Capacitacion
        </Typography>

        {cargandoDatos ? (
          <CircularProgress />
        ) : (
          <>
            <TextField fullWidth label="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="Descripción" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth type="date" label="Fecha Inicio" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} sx={{ mb: 2 }} InputLabelProps={{ shrink: true }} />
            <TextField fullWidth label="Duración" value={duracion} onChange={(e) => setDuracion(e.target.value)} sx={{ mb: 2 }} />
            <TextField
              select
              fullWidth
              label="Instituto"
              value={instituto}
              onChange={(e) => setInstituto(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ mb:2 }}
            >
              <option value=""> </option>
              <option value="INFOPRO">INFOPRO</option>
              <option value="CLADECORP">CLADECORP</option>
            </TextField>
            <TextField select fullWidth label="Estado" value={estado} onChange={(e) => setEstado(parseInt(e.target.value))} sx={{ mb: 2 }}>
              <MenuItem value={1}>Activo</MenuItem>
              <MenuItem value={0}>Inactivo</MenuItem>
            </TextField>

            <MDButton variant="contained" color="info" fullWidth onClick={handleSubmit} disabled={loading} >
              {loading ? <CircularProgress size={24} /> : "Guardar cambios"}
            </MDButton>
          </>
        )}
      </Box>
    </Modal>
  );
}
